import React from 'react';
import cn from 'classnames';

import type { HintProps } from '../types';

const Hint = ({ children, className }: HintProps) => {
  return <div className={cn('e-input__hint', className)}>{children}</div>;
};

export default Hint;
